const MediaLibraryCollection = Backbone.Collection.extend({
  name: 'medialibrary',
  sync(method, collection, options) {
    // Possible methods: create, read, update, dete
    const defer = $.Deferred();

    if (typeof options === 'undefined') {
      options = {};
    }

    options.reset = (options.reset === undefined ? true : options.reset);

    if (method == 'read') {
      let params = {};
      params = $.extend(true, {}, _.omit(options, ['parse', 'success', 'silent', 'reset', 'remove', 'error', 'refreshCache', 'setPermissionData', 'ignoreCache', 'user_id']));

      return Sendible.Connect.getMediaLibraries(
        window.appConfig.applicationId,
        $username,
        $password,
        (data) => {
          options.success(data.result.data);
          defer.resolve(data.result.data);
        },
        (data) => {
          options.error(data);
          defer.reject(data);
        },
        params,
      );
    }

    return defer.promise();
  },
});

export default MediaLibraryCollection;
